// 左侧头像

import React, { useCallback, useMemo } from "react";
import "./index.less";
import IconFont from "@/components/icon";
import { Tooltip } from "antd";
import classNames from "classnames";
import { SessionType } from "@/types/chat";
import ownerPng from "./pic/badge@3x.png";
import adminPng from "./pic/admin@3x.png";
import { HeadShowType } from "@/types/chat/enum";
import { Avatar } from "@/baseComponents/Avatar";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import { changeEgovUrl } from "@/utils/tools";
import ComGroupAlias from "@/baseComponents/ComGroupAlias";
import { tagsNode } from "@/components/AddressBook/common";
import { InvitingTag } from "@/components/Tags";
// import Badge from "@/baseComponents/Badge";
import { Badge } from "@jd/focus-desktop-comps";
interface HeadPortraitProps {
  width: any; // 宽
  height: any; // 高
  fontSize?: any; // 文字大小
  imgUrl: string; // 头像地址
  name: string; // 名称
  showType?: HeadShowType;
  type?: SessionType; // 事件
  numPieces?: number; // 右上角消息数量
  isLeader?: boolean; // 是否是群主
  isUnFollow?: boolean; // 是否右击出发取消置顶，true为取消
  onOpenSession?: Function;
  onItemClick?: Function;
  mentions?: any;
  currentEmployee?: any;
  clstag?: string;
  isAdmin?: boolean;
  desc?: string; // IM组成员列表显示单位/部门+职位
  member?: any;
  session?: any;
  keyword?: string; // 组成员模糊搜素关键字高亮
  showExternalTag?: boolean; // 是否展示外部标签
  showAlias?: boolean; // 是否展示昵称
  showGroupRoleTag?: boolean; // 是否展示群角色标签
  avatarMask?: boolean; // 是否添加头像蒙层
  shield?: boolean; // 是否开启免打扰
}

type IProps = Readonly<HeadPortraitProps>;
function HeadPortrait(props: IProps) {
  const {
    numPieces,
    name,
    showType,
    width,
    height,
    fontSize,
    imgUrl,
    onOpenSession,
    onItemClick,
    mentions,
    currentEmployee,
    desc,
    type,
    member,
    session,
    keyword,
    showExternalTag,
    showAlias = true,
    showGroupRoleTag = false,
    avatarMask = true,
    shield = false
  } = props;

  const getNumPiecesPart = () => {
    if(shield && numPieces){
      return <Badge dot style={{ right: 2, top: 2 }} className="badge-top-right" />
    } else if (mentions && Object.values(mentions).length > 0) {
      return <Badge style={{ right: 4, top: 2, fontSize: 16}} className="badge-top-right" icon={<IconFont type="icontiji1" />} />
      //  return (
      //     <div className="num-pieces">
      //       <div className="number" id="aite">
      //         <IconFont type="icontiji1" />
      //       </div>
      //     </div>
      //   );
    } else if (numPieces) {
      return (
        <Badge style={{ right: 4, top: 2 }} className="badge-top-right" value={numPieces} />
        // <div
        //   className={classNames({
        //     "num-pieces": true,
        //     more: Number(numPieces) > 9,
        //     moremore: Number(numPieces) > 99
        //   })}
        // >
        //   {Number(numPieces) > 99 ? (
        //     <div className="number">99+</div>
        //   ) : (
        //     <div className="number">{numPieces}</div>
        //   )}
        // </div>
      );
    } else {
      return null;
    }
  };
  const onClick = useCallback(() => {
    if (showType === HeadShowType.TOP) {
      if (onOpenSession) {
        onOpenSession();
        return;
      }
    }
    if (onItemClick) {
      onItemClick();
    }
  }, [onItemClick, onOpenSession, showType]);

  const getNamePart = useCallback(() => {
    if (showType === HeadShowType.GROUP_MEMBER || (showType === HeadShowType.TOP && name)) {
      let highName = name;
      if (keyword?.length) {
        let replaceReg = new RegExp(keyword, "g");
        let replaceString = '<span class="highlight-text">' + keyword + "</span>";
        highName = highName.replace(replaceReg, replaceString);
      } else {
        highName = name;
      }
      return (
        <div className="name-box">
          <div className="user-name" dangerouslySetInnerHTML={{ __html: highName }} />
          {showAlias && <ComGroupAlias user={member.info} session={session} keyword={keyword} />}
          {showGroupRoleTag && props.isLeader && <span
            className="user-tags"
            style={{color: "#0073FF", backgroundColor: "rgba(0, 115, 255, 0.20)", borderRadius: "4px"}}
          >
            群主
          </span>
          }
          {showGroupRoleTag && props.isAdmin && <span
            className="user-tags"
            style={{color: "#00BF49", backgroundColor: "rgba(0, 191, 73, 0.20)", borderRadius: "4px"}}
          >
            管理员
          </span>}
          {showExternalTag && tagsNode(member?.user?.labelInfoList || member?.labelInfoList)}
          {member?.invitedTag && <InvitingTag />}
        </div>
      );
    }
  }, [showType, name, keyword, member, session, showExternalTag, showAlias]);

  const getImagePart = useCallback(() => {
    const headImgThumbUrl = getHeadImgThumbUrl(imgUrl, 150, 150);
    
    // console.log('0000000', headImgThumbUrl);

    if (!headImgThumbUrl) {
      return (
        <Avatar
          tag={member?.info?.accountType === 1 ? "公共账号" : ""}
          name={name}
          styleObj={{ width, height, fontSize }}
          onClick={onClick}
        />
      );
    }
    // console.log(headImgThumbUrl, 115);
    return (
      <span clstag={props.clstag}>
        <Avatar
          tag={member?.info?.accountType === 1 ? "公共账号" : ""}
          src={changeEgovUrl(headImgThumbUrl)}
          name={name}
          styleObj={{ width, height, fontSize }}
          onClick={onClick}
          className="avatarNoDraggable"
          avatarMask={avatarMask}
          type={type === SessionType.GROUP ? 'group' : 'user'}
        />
      </span>
    );
  }, [imgUrl, props.clstag, member, name, width, height, fontSize, onClick]);

  const toolTipTitle = useMemo(() => {
    if (showType === HeadShowType.TOP) {
      if (name.length >= 13) {
        return name.slice(0, 13).concat("...");
      } else {
        return name;
      }
    }
  }, [name, showType]);

  return (
    <Tooltip title={toolTipTitle} overlayClassName="head-portrait-tooltip">
      <div className="head-portrait-container">
        <div className="head-img">
          {showType === HeadShowType.TOP && type === SessionType.SECRET_SINGLE && (
            <div className="secret-head-img_mask">
              <IconFont type="icona-ic_app_im_Secretchat_facet" />
            </div>
          )}
          {getImagePart()}
          {!showGroupRoleTag && (props.isLeader || props.isAdmin) && (
            <img
              onDragStart={(e) => {
                return false;
              }}
              src={changeEgovUrl(props.isLeader ? ownerPng : adminPng)}
              alt=""
              className="especially"
              draggable="false"
            />
          )}
          {getNumPiecesPart()}
        </div>
        {/* {getNamePart()} */}
        { desc ? (
          <div className="name-wrapper">
            {getNamePart()}
            <div className="desc" dangerouslySetInnerHTML={{ __html: desc }} />
          </div>
        ) : (
          getNamePart()
        )}
      </div>
    </Tooltip>
  );
}

export default HeadPortrait;
